import PageTemplate from '../components/PageTemplate';

const YourselfPage = () => (
  <PageTemplate
    page="yourself"
    pageName="Yourself"
    tagline="Invest in the person you're becoming."
    icon="🌱"
    accentColor="#4CAF50"
    about={{
      title: "The Most Important Investment You'll Ever Make",
      paragraph1: 'Before you invest a dollar in the market or a minute in community service, you must first invest in yourself. Personal development is the foundation upon which all other investments rest.',
      paragraph2: 'The Village Investors believes in a holistic approach to self-investment: physical vitality, mental clarity, emotional resilience, and spiritual depth.',
      points: [
        'Continuous learning and skill development',
        'Health, fitness, and longevity practices',
        'Mindset, habits, and emotional intelligence',
        'Building meaningful relationships and networks',
      ]
    }}
  />
);

export default YourselfPage;
